export default __webpack_public_path__ + "b7804e2858ca007ea03f3054bebcf5d6.svg";